window.SgWishlist = (function () {
  var STORAGE_KEY = 'sg-wishlist';

  function getAll() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function save(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: items } }));
  }

  function has(id) {
    return getAll().some(function (item) {
      return String(item.id) === String(id);
    });
  }

  function add(product) {
    var items = getAll();
    if (!has(product.id)) {
      items.push(product);
      save(items);
    }
  }

  function remove(id) {
    var items = getAll().filter(function (item) {
      return String(item.id) !== String(id);
    });
    save(items);
  }

  function toggle(product) {
    if (has(product.id)) {
      remove(product.id);
      return false;
    }
    add(product);
    return true;
  }

  function count() {
    return getAll().length;
  }

  function readProductFromButton(button) {
    return {
      id: button.dataset.productId,
      handle: button.dataset.productHandle,
      title: button.dataset.productTitle,
      price: Number(button.dataset.productPrice),
      image: button.dataset.productImage,
      available: button.dataset.productAvailable === 'true'
    };
  }

  function syncButton(button) {
    var active = has(button.dataset.productId);
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
  }

  function initToggles(root) {
    (root || document).querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      syncButton(button);

      button.addEventListener('click', function (event) {
        event.preventDefault();
        var active = toggle(readProductFromButton(button));
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initToggles(document);
  });

  document.addEventListener('wishlist:change', function () {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(syncButton);
  });

  return {
    STORAGE_KEY: STORAGE_KEY,
    getAll: getAll,
    has: has,
    add: add,
    remove: remove,
    toggle: toggle,
    count: count,
    initToggles: initToggles
  };
})();
